import axios from "axios"

export const activities = () => axios.get("/api/v2/activities")

export const markAsSeen = (id) => axios.post(`/api/v2/activities/${id}/mark_as_seen`)

export const resetUnreadActivitiesCounter = () => axios.post("/api/v2/new_activities/mark_as_seen")

export const markAllAsRead = () => axios.post("/api/v2/activities/mark_all_as_seen")

export const undoMarkAllAsRead = () => axios.post("/api/v2/activities/undo_mark_all_as_seen")

export const updateActivitiesBlocks = (activity_exclusions) =>
  axios.post("/api/v2/activity_exclusions", {
    activity_exclusions
  })

export const activitiesBlocks = () => axios.get("/api/v2/activity_exclusions")
